
import { Injectable } from '@angular/core';

export enum StorageKeys {
  AccessToken = 'access_token',
  RefreshToken = 'refresh_token',
  UserInfo = 'user_info',
  Theme = 'theme',
  TenantCode = "TenantCode",
  UserRole = "UserRole",
  UserId = "UserId",
  CurrentSchool = "CurrentSchool",
  CurrentOrganization = "CurrentOrganization",
  CurrentAcademicYear = 'current_academic_year',
}

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem<T>(key: StorageKeys, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: StorageKeys): T | null {
    const value = localStorage.getItem(key);
    if (!value) return null;
    try {
      return JSON.parse(value) as T;
    } catch (error) {
      console.error(`Error parsing localStorage key "${key}":`, error);
      return null;
    }
  }

  removeItem(key: StorageKeys): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
